import { CandidateModel } from '../ts/interfaces/models/CandidateModel';
import { BaseService } from './baseService';

class CandidateService extends BaseService<CandidateModel> {
  controllerName = 'candidate';
}

export const candidateService = new CandidateService();
